import { AppBar, Box, Button, Checkbox, Collapse, Container, Dialog, Grid, Icon, IconButton, ListItemText, MenuItem, Select, Tab, Tabs, Typography, Radio, RadioGroup } from '@material-ui/core';
import { NoteAdd, AddBox, ControlPointDuplicateSharp } from '@material-ui/icons';
import UserImpl from 'uscc-services/lib/model/UserImpl';
import AddressImpl from 'uscc-services/lib/model/AddressImpl';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import ValidationEvent from 'components/ui/form/ValidationEvent';
import Page from 'components/pages/Page';
import ValidatedTextField from 'components/ui/form/ValidatedTextField';
import ValidatedSelect from 'components/ui/form/ValidatedSelect';
import React, { useState, useEffect } from 'react';
import User from 'uscc-services/lib/model/User';
import { Link } from 'react-router-dom';
import Range from 'uscc-services/lib/model/Range';
import CovidStatus from 'uscc-services/lib/model/CovidStatus';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import USStateSelect from 'components/ui/form/USStateSelect';
import CountrySelect from 'components/ui/form/CountrySelect';
import ResumeDropZone from 'components/ui/form/ResumeDropZone';
import { bus } from 'components/events/EventBus';
import { Events } from 'components/events/Events';
import ProgressBar from 'components/ui/form/ProgressBar';
import get from 'just-safe-get';
import { getAuthHeader, getCognitoUserInfo } from '../auth'
import { parseTwoDigitYear } from 'moment';
import Loading from 'components/ui/Loading';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const { api, apiKey, apiEndpoint } = require('../../config')
const axios = require('axios').default;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper:      { padding: '2em' },
    disabledLabel:    { color: '#999' },
    pageTitle:        { borderBottom: '1px solid rgba(0, 0, 0, 0.12)', paddingBottom: '.5em' },
    tabsContainer:    { flexGrow: 1, backgroundColor: theme.palette.background.paper, display: 'flex', position: 'relative' },
    // tabs:             { borderRight: `1px solid ${theme.palette.divider}` },
    tabLabel:         { 
      '@media (min-width: 0px)': {
        fontSize: '10px !important'
      },
      '@media (min-width: 600px)': {
        fontSize: '12px !important'
      },
      '@media (min-width: 960px)': {
        fontSize: '14px !important'
      }
     },
    root:             { flexGrow: 1, backgroundColor: theme.palette.background.paper, display: 'flex' },
    shortInput:       { maxWidth: '24ch' },
    bottom:           { marginTop: '2em' },
    right:            { float: 'right' },
    indent:           { marginLeft: '1em', fontSize: '1rem' },
    button:           { padding: '10px 20px' },
    buttonIcon:       { marginRight: '0.33em' },
    completedIcon:    { marginLeft: '0.33em', display:'inline !important', fontSize: '1.4em', lineHeight: 1, position: 'relative', top: '0.1em' },
    completedTabLabel:{ whiteSpace: 'nowrap' },
    centeredPage:     { margin: '0 auto', width: '75vw', maxWidth: '1024px' },
    column:           { textAlign: 'left', color: theme.palette.text.secondary },
    textField:        { 
      marginLeft: theme.spacing(1), marginRight: theme.spacing(1), width: '90%' 
    },
    dense:            { marginTop: theme.spacing(2) },
    form:             { padding: '.5vw 2vw', border: '1px solid #6D9E11', borderRadius: '4px' },
    img:              { width: '100%', maxWidth: '300px' },
    extendedIcon:     { marginRight: theme.spacing(1) },
    squareTop:        { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
    tiny:             { fontSize: '10pt' },
    validField:       {},
    invalidField:     { backgroundColor: '#FFcccc' },
    left:             { float: 'left' },
    noTopMargin:      { marginTop: '0px' },
    legalText:        { fontSize: '1em', margin: '0px' }    
  }),
);

let sessionToken = localStorage.getItem('user') || '{}'
let user: User = JSON.parse(sessionToken) as User;

interface Form {}

export class LicenseForm implements Form{
  name: string = '';
  state: string = '';
  number: string = '';
  activationDate: string = '';
  expirationDate: string = '';
}

export class ProfileForm implements Form {
  firstName: string = user.firstName || '';
  lastName: string = user.lastName || '';
  addressLine1: string = "";
  addressLine2: string = "";
  email: string = user.email || '';
  licenses: LicenseForm[] = [];
  specialities: string[] = [];
  populationExperience: string[] = [];
  phoneNumber: string = "";
  notes: string = "";
  maxTravelMiles: string = "";
  annualSalaryUSDollar: Range<number> = {} as Range<number>;
  covidStatus: CovidStatus = CovidStatus.NOT_REPORTED;
  salaryType: string = "hourly";
  lowerSalary : string = "";
  upperSalary : string = "";
  addressState: string = "";
  addressCity: string = "";
  addressCountry: string = "";
  addressZipCode: string = "";
  employmentStatus: string = "";
  employerName: string = "";
  jobName: string = "";
  studentMajor: string = "";
  relocatable: string = "";
  relocationZipCode1: string = "";
  relocationZipCode2: string = "";
  relocationZipCode3: string = "";
  relocationReqHousing1: string = "";
  relocationReqHousing2: string = "";
  relocationReqHousing3: string = "";
  recentExperience: string = "";
  certifications: string[] = [];
  partTimeInterest: boolean = false;
  fullTimeInterest: boolean = false;
  availableToStart: string = "";
  retirementStatus:string='';
  languageSpoken:string=''
  daysOfTheWeekAvailability: string[] = [];
  telehealthAvailability: string = "";
  treatCovidPatients: string = "";
  treatCriticalCarePatients: string = "";
  orgName: string = "";
  orgZipCode: string = "";
  orgState: string = "";
  orgCountry: string = "";
  orgCity: string = "";
  orgAddressLine2: string = "";
  orgAddressLine1: string = "";
  orgEmail: string = "";
  orgPhone: string = "";
  orgWebsite: string = "";

}

function getProperty<T, K extends keyof T>(o: T, propertyName: K): T[K] {
  return o[propertyName]; // o[propertyName] is of type T[K]
}

const availableSpecialities: string[] = [
  'Nurse - Advanced Practice Nurse',
  'Nurse - Certified Nurse Specialist',
  'Nurse - Licensed Practical Nurse',
  'Nurse - Nurse Anesthetist',
  'Nurse - Nurse Practitioner',
  'Nurse - Registered Professional Nurse',
  'Nurse - School Nurse',
  'Mental Health - Counselor',
  'Mental Health - Licensed Clinical Social Worker',
  'Mental Health - Psychologist',
  'Mental Health Professional - Other',
  'Physician - Anesthesiologist',
  'Physician - Emergency Department',
  'Physician - Family Medicine',
  'Physician - Infectious Disease',
  'Physician - Intensive Care',
  'Physician - Internal Medicine',
  'Physician - OB/GYN',
  'Physician - Psychiatrist',
  'Physician - Pulmonologist',
  'Physician - Radiologist',
  'Physician - Surgeon',
  'Physician - Other',
  'Respiratory Therapist',
  'Respiratory Therapy Technician',
  'Acupuncturist',
  'Certified Home Health Aide',
  'Certified Nurse Aide',
  'Chiropractor',
  'Clinical Laboratory Technician',
  'Clinical Laboratory Technologist',
  'Clinical Nurse Specialist',
  'Dental Hygienist',
  'Dentist',
  'Doula',
  'Emergency Medical Technician (EMT)',
  'Licensed Clinical Social Worker',
  'Medical Assistant',
  'Medical Technologist',
  'Midwife',
  'Mobility Assistant Vehicle Operator/Livery Service',
  'Occupational Therapist',
  'Optometrist',
  'Other Critical Care Medicine',
  'Paramedic',
  'Perfusionist',
  'Pharmacist',
  'Phlebomotist',
  'Physician Assistant',
  'Podiatrist',
  'Rehabilitation Counselor',
  'Respiratory Therapists',
  'Specialist Assistant',
  'Sports Medicine / Athletic Trainer',
  'Veterinary Technician (Vet Tech)',
  'Veterinarian',
  'X-Ray Technician',
  'Other'
];

const availableLicenses: string[] = availableSpecialities;

// const availableCovidStatuses: string[] = Object.values(CovidStatus);

const availablePopulationExperiences: string[] = [
  "Pediatrics",
  "Adults",
  "Geriatrics",
  "N/A"
]

const availableEmploymentStatuses: string[] = [
  "Employed Full-Time",
  "Employed Part-Time",
  "Furloughed",
  "Unemployed",
  "Retired",
  "Student"
]

const availableRecentExperienceOptions: string[] = [
  "Currently Practicing",
  "Within Past 6 Months",
  "6 Months - 2 Years",
  "Over 2 Years Ago"
]

// const availableTravelDistances: any[] = [
//   { label: "None", value: 'none' },
//   { label: "Up to 25 miles", value: '25' },
//   { label: "Up to 50 miles", value: '50' },
//   { label: "Up to 75 miles", value: '75' },
//   { label: "Up to 100 miles", value: '100' },
//   { label: "Anywhere", value: '0'}
// ];

const availableToStartOptions: any[] = [
  { label: "Now", value: '0' },
  { label: "Within 2 weeks", value: '1' },
  { label: "Within 1 month", value: '2' },
  { label: "Within 2 months", value: '3' },
  { label: "More than 2 months", value: '4' },
  { label: "Unknown", value: '5' }
]
const retirementStatusOptions:any[]=[
  { label: "3 months", value: '0' },
  { label: "6 months", value: '1' },
  { label: "12 months+", value: '2' },
]
const languagesSpokenOptions:any[]=[
  { label: "English", value: '0' },
  { label: "German", value: '1' },
  { label: "French", value: '2' },
]
const daysOfTheWeek: string[] = [
  "Monday AM",
  "Monday PM",
  "Monday PRN/Occasional",
  "Tuesday AM",
  "Tuesday PM",
  "Tuesday PRN/Occasional",
  "Wednesday AM",
  "Wednesday PM",
  "Wednesday PRN/Occasional",
  "Thursday AM",
  "Thursday PM",
  "Thursday PRN/Occasional",
  "Friday AM",
  "Friday PM",
  "Friday PRN/Occasional",
  "Saturday AM",
  "Saturday PM",
  "Saturday PRN/Occasional",
  "Sunday AM",
  "Sunday PM",
  "Sunday PRN/Occasional"
]

function a11yProps(index: any) {
  return {
    id: `horizontal-tab-${index}`,
    'aria-controls': `horizontal-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{width:'100%'}}
      hidden={value !== index}
      id={`horizontal-tabpanel-${index}`}
      aria-labelledby={`horizontal-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={{ xs: 1, sm:2, md: 3}}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function ProfilePage(props: any) {
  const { pathname = '/' } = get(props, 'location') || {}
  const id = pathname.split('/').pop()
  const cognitoUserInfo = getCognitoUserInfo() || {}
  const classes = useStyles(props.theme);
  const [userLoaded, setUserLoaded] = useState(false)
  const [alreadyAgreedToTerms, setAlreadyAgreedToTerms] = useState(false)
  const [agreesToTerms, setAgreesToTerms] = useState(false)
  const [profileForm, setProfileForm] = useState<ProfileForm>(new ProfileForm());  
  const [resumeFilename, setResumeFilename] = useState<string>("");
  const [licenseForm, setLicenseForm] = useState<LicenseForm>(new LicenseForm());  
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [isAddLicenseModalVisible, setIsAddLicenseModalVisible] = useState<boolean>(false);
  const [contactInfoLabel, setContactInfoLabel] = useState<JSX.Element | undefined>(<div>Contact Info</div>);
  const [contactInfoCompleted, setContactInfoCompleted] = useState<number>(0);
  const [workStatusLabel, setWorkStatusLabel] = useState<JSX.Element | undefined>(<div>Work Status</div>);
  const [workStatusCompleted, setWorkStatusCompleted] = useState<number>(0);
  const [availabilityLabel, setAvailabilityLabel] = useState<JSX.Element | undefined>(<div>Availability</div>);
  const [availabilityCompleted, setAvailabilityCompleted] = useState<number>(0);
  const [preferencesLabel, setPreferencesLabel] = useState<JSX.Element | undefined>(<div>Preferences</div>);
  const [preferencesCompleted, setPreferencesCompleted] = useState<number>(0);
  const [resumeLabel, setResumeLabel] = useState<JSX.Element | undefined>(<div>Resume</div>);
  const [isLoading, setIsLoading] = useState<boolean>(false)
    
  const [validations, setValidations] = useState<any>({
    firstName: true,
    lastName: true,
    email: true
  });
  
  function addLicense() {
    let license: LicenseForm = Object.assign({}, licenseForm)
    profileForm.licenses.push(license)
    setLicenseForm(new LicenseForm())
    setIsAddLicenseModalVisible(false)
  }

  useEffect(() => {
    let updateContactInfoLabel = (form: ProfileForm) => {
      let completed: number = 0;
      if(('' + form.firstName).length > 0) completed += 1
      if(('' + form.lastName).length > 0) completed += 1
      // if(('' + form.email).length > 0) completed += 1
      if(('' + form.phoneNumber).length > 0) completed += 1
      if(('' + form.addressCountry).length > 0) completed += 1
      if(('' + form.addressLine1).length > 0 || ('' + form.addressLine2).length > 0) completed += 1
      if(('' + form.addressCity).length > 0) completed += 1
      if(('' + form.addressState).length > 0) completed += 1
      if(('' + form.addressZipCode).length > 0) completed += 1
    
      let percentage: number = Math.round((completed/8) * 100)
      setContactInfoCompleted(completed)
      let label = () => {
        return (
          <div className={classes.tabLabel}>
            {percentage > 99 ? <span className={classes.completedTabLabel}><Icon color = 'primary' className = { clsx(classes.completedIcon,  'fa fa-check-circle') } /> Contact Info</span> : <div><span>Contact Info</span>{percentage > 0 && <ProgressBar percentage={percentage}/>}</div> }
          </div>
        )
      }
    
      return label
    }
    
    let updateWorkStatusLabel = (form: ProfileForm) => {
      let completed: number = 0;
      if(('' + form.specialities).length > 0) completed += 1
      if(('' + form.employmentStatus).length > 0) completed += 1
      if(('' + form.recentExperience).length > 0) completed += 1
      if(('' + form.populationExperience).length > 0) completed += 1
      // if(('' + form.certifications).length > 0) completed += 1
      
      let percentage: number = Math.round((completed/4) * 100)
      setWorkStatusCompleted(completed)
      let label = () => {
        return (
          <div className={classes.tabLabel}>
            {percentage > 99 ? <span className={classes.completedTabLabel}><Icon color = 'primary' className = { clsx(classes.completedIcon,  'fa fa-check-circle') } /> Work Status</span> : <div><span>Work Status</span>{percentage > 0 && <ProgressBar percentage={percentage}/>}</div> }
          </div>
        )
      }
    
      return label
    }
    
    let updateAvailabilityLabel = (form: ProfileForm) => {
      let completed: number = 0;
      if(('' + form.lowerSalary).length > 0) completed += 1
      if(('' + form.upperSalary).length > 0) completed += 1
      if(form.fullTimeInterest || form.partTimeInterest) completed += 1
      if(('' + form.relocatable).length > 0) completed += 1
      if(('' + form.availableToStart).length > 0) completed += 1
      if(('' + form.daysOfTheWeekAvailability).length > 0) completed += 1
  
      let percentage: number = Math.round((completed/6) * 100)

      setAvailabilityCompleted(completed)
      let label = () => {
        return (
          <div className={classes.tabLabel}>
            {percentage > 99 ? <span className={classes.completedTabLabel}><Icon color = 'primary' className = { clsx(classes.completedIcon,  'fa fa-check-circle') } /> Availability</span> : <div><span>Availability</span>{percentage > 0 && <ProgressBar percentage={percentage}/>}</div> }
          </div>
        )
      }
    
      return label
    }
  
    let updatePreferencesLabel = (form: ProfileForm) => {
      let completed: number = 0;
      // if(('' + form.profilePicture).length > 0) percentage += (1/11)
      if(('' + form.telehealthAvailability).length > 0) completed += 1
      if(('' + form.treatCovidPatients).length > 0) completed += 1
      if(('' + form.treatCriticalCarePatients).length > 0) completed += 1
  
      let percentage: number = Math.round((completed/3) * 100)
      setPreferencesCompleted(completed)
      let label = () => {
        return (
          <div className={classes.tabLabel}>
            {percentage > 99 ? <span className={classes.completedTabLabel}><Icon color = 'primary' className = { clsx(classes.completedIcon,  'fa fa-check-circle') } /> Preferences</span> : <div><span>Preferences</span>{percentage > 0 && <ProgressBar percentage={percentage}/>}</div> }
          </div>
        )
      }
    
      return label
    }    

    let updateResumeLabel = (form: ProfileForm) => {
      let label = () => {
        return (
          <div className={classes.tabLabel}>
            <span>Resume</span>
          </div>
        )
      }
    
      return label
    }

    setContactInfoLabel(updateContactInfoLabel(profileForm));
    setWorkStatusLabel(updateWorkStatusLabel(profileForm));
    setAvailabilityLabel(updateAvailabilityLabel(profileForm));
    setPreferencesLabel(updatePreferencesLabel(profileForm));
    setResumeLabel(updateResumeLabel(profileForm));

  }, [profileForm])

  useEffect(() => {
    if(!userLoaded) {
      setUserLoaded(true)
      // console.log(userLoaded)
      bus.emit(Events.loadingChange, {isLoading: true});
      getUser()
    }
  })
    // // Create an scoped async function in the hook
    // async function anyNameFunction() {
    //   const fetchedUser = await getUser(id)
    //   console.log(fetchedUser)
    //   const updatedForm = Object.assign(
    //     { ...form },
    //     fetchedUser,
    //     {
    //       addressLine1: get(fetchedUser, 'address.line1'),
    //       addressLine2: get(fetchedUser, 'address.line2'),
    //       city: get(fetchedUser, 'address.city'),
    //       country: get(fetchedUser, 'address.country'),
    //       state: get(fetchedUser, 'address.state'),
    //       zipCode: get(fetchedUser, 'address.zipCode')
    //     }
    //   )
    //   console.log(updatedForm)
    //   setForm(updatedForm)
    // }
    // // Execute the created function directly
    // anyNameFunction();

  async function getUser() {
    try {
      let response = await axios({
        url: `${apiEndpoint}/user`,
        method: 'GET',
        headers: {
          'x-api-key': apiKey,
          'Authorization': getAuthHeader()
        },
        responseType: "application/json"
      });

      
      const theuser = get(response, 'data')
      // console.log(theuser)
      if(theuser) {
        if(theuser.agreesToTerms) {
          setAlreadyAgreedToTerms(true)
        }
        setAgreesToTerms(theuser.agreesToTerms)
        const form: ProfileForm = new ProfileForm()
        form.firstName = theuser.firstName || '';
        form.lastName = theuser.lastName || '';
        form.addressLine1 = theuser.address.line1 || "";
        form.addressLine2 = theuser.address.line2 || "";
        form.email = theuser.email || '';
        form.licenses = (theuser.licenses || []).reduce((s:any, l: any) => {
          try {
            let parsed = JSON.parse(l)
            s.push(parsed)
          } catch(err) {

          }
          return s
        }, []);
        form.specialities = theuser.specialities || [];
        form.populationExperience = theuser.populationExperience || [];
        form.phoneNumber = theuser.phoneNumber || "";
        form.notes = theuser.notes || "";
        form.maxTravelMiles = theuser.maxTravelMiles || "";
        form.annualSalaryUSDollar = theuser.annualSalaryUSDollar || {};
        form.covidStatus = theuser.covidStatus || CovidStatus.NOT_REPORTED;
        form.salaryType = theuser.salaryType || "hourly";
        form.lowerSalary = theuser.lowerSalary || "";
        form.upperSalary = theuser.upperSalary || "";
        form.addressState = theuser.address.state || "";
        form.addressCity = theuser.address.city || "";
        form.addressCountry = theuser.address.country || "";
        form.addressZipCode = theuser.address.zipCode || "";
        form.employmentStatus = theuser.employmentStatus || "";
        form.employerName = theuser.employerName || "";
        form.jobName = theuser.jobName || "";
        form.studentMajor = theuser.studentMajor || "";
        form.relocatable = theuser.willRelocate === undefined || theuser.willRelocate === null ? '' : theuser.willRelocate ? '1' : '0';
        form.relocationZipCode1 = theuser.relocationZipCode1 || "";
        form.relocationZipCode2 = theuser.relocationZipCode2 || "";
        form.relocationZipCode3 = theuser.relocationZipCode3 || "";
        form.relocationReqHousing1 = theuser.relocationReqHousing1 === undefined || theuser.relocationReqHousing1 === null ? '' : theuser.relocationReqHousing1 ? '1' : '0';
        form.relocationReqHousing2 = theuser.relocationReqHousing2 === undefined || theuser.relocationReqHousing2 === null ? '' : theuser.relocationReqHousing2 ? '1' : '0';
        form.relocationReqHousing3 = theuser.relocationReqHousing3 === undefined || theuser.relocationReqHousing3 === null ? '' : theuser.relocationReqHousing3 ? '1' : '0';
        form.recentExperience = theuser.recentExperience || "";
        form.certifications = theuser.certifications || [];

        const {employmentSought = '0'} = theuser
        // 0 = none
        // 1 = part-time
        // 2 = full time
        // 3 = both
        form.partTimeInterest = ['1','3'].indexOf(employmentSought) > -1 || false;
        form.fullTimeInterest = ['2','3'].indexOf(employmentSought) > -1 || false;

        form.availableToStart = theuser.availableToStart || "";
        form.retirementStatus = theuser.retirementStatus || "";
        form.languageSpoken = theuser.languageSpoken || "";

        form.daysOfTheWeekAvailability = [
          theuser.sundayAvailability ? `Sunday ${theuser.sundayAvailability}` : '',
          theuser.mondayAvailability ? `Monday ${theuser.mondayAvailability}` : '',
          theuser.tuesdayAvailability ? `Tuesday ${theuser.tuesdayAvailability}` : '',
          theuser.wednesdayAvailability ? `Wednesday ${theuser.wednesdayAvailability}` : '',
          theuser.thursdayAvailability ? `Thursday ${theuser.thursdayAvailability}` : '',
          theuser.fridayAvailability ? `Friday ${theuser.fridayAvailability}` : '',
          theuser.saturdayAvailability ? `Saturday ${theuser.saturdayAvailability}` : ''
        ].filter(f => f !== '')
        // console.log(form.daysOfTheWeekAvailability)
        // shiftAvailability: string[] = [];
        form.telehealthAvailability = theuser.telehealthAvailability === undefined || theuser.telehealthAvailability === null ? '' : theuser.telehealthAvailability ? '1' : '0';
        form.treatCovidPatients = theuser.treatCovidPatients || "";
        form.treatCriticalCarePatients = theuser.inPersonCare || "";
        form.orgName = theuser.orgName || "";
        form.orgZipCode = theuser.orgZipCode || "";
        form.orgState = theuser.orgState || "";
        form.orgCountry = theuser.orgCountry || "";
        form.orgCity = theuser.orgCity || "";
        form.orgAddressLine2 = theuser.orgAddressLine2 || "";
        form.orgAddressLine1 = theuser.orgAddressLine1 || "";
        form.orgEmail = theuser.orgEmail || "";
        form.orgPhone = theuser.orgPhone || "";
        form.orgWebsite = theuser.orgWebsite || "";
        setProfileForm(form)
        setResumeFilename(theuser.resumeFilename)
      }

    } catch (err) {
      console.log(err);
      const message = get(err, 'message');
      bus.emit(Events.onAlert, {
        message,
        severity: 'error',
        duration: 5000
      });
    }
  }

  let downloadResume = async () => {
    const opts = {
      url: `${apiEndpoint}/profile/download-url?fileName=${resumeFilename}`,
      method: 'GET',
      headers: {
        'Authorization': getAuthHeader(),
        'x-api-key': apiKey
      }
    }

    let response = await axios(opts);
    if(response && response.data && response.data.url) {
      window.open(response.data.url, '_blank');
        // let a: any = document.createElement('a');
        // a.style = 'display:none';
        // document.body.appendChild(a);
        // a.href = response.data.url
        // a.target = '_blank'
        // a.download = resumeFilename;
        // a.click();
        // document.body.removeChild(a);
    }
  }

  let uploadResume = async (resumeFile: File) => {
    if(resumeFile) {      
      try {
        const opts = {
          url: `${apiEndpoint}/profile/upload-url?fileName=${resumeFile.name}`,
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': getAuthHeader(),
            'x-api-key': apiKey
          }
        }
        let response = await axios(opts);
        let { target } = response.data
        

        let data: FormData = Object.keys(target.fields).reduce((data, key) => {
          data.append(key, target.fields[key])
          return data
        }, new FormData())
        // let data = {file: resumeFile}
        data.append('file', resumeFile)
        let response2 = await axios.post(target.url, data, {headers: { 'Content-Type': 'multipart/form-data' }})
        setResumeFilename(resumeFile.name)
        bus.emit(Events.onAlert, {
          message: 'Resume Uploaded',
          duration: 5000
        });
      } catch (err) {
        console.log(err);
        const message = get(err, 'response.data');
        bus.emit(Events.onAlert, {
          message,
          severity: 'error',
          duration: 5000
        });
      }

      
    } else {
      //select a file to upload first!
    }

    
  }

  let onProfileFormChange = (event: React.ChangeEvent<HTMLInputElement | {name?: string, value:unknown, checked?: boolean}>) => {
    let { target } = event;

    let {value} = target;
    let name: string = target.name || '';
    let nameParts = ('' + name).split('.')
    if(nameParts.length > 1) {
      nameParts.shift()
      name = nameParts.join();
    }

    switch(name) {
      case 'licenses':
        value = profileForm.licenses.filter(item => JSON.stringify(item) !== value);
        break
      case 'partTimeInterest':
      case 'fullTimeInterest':
        value = target.checked;
        break;
      case 'populationExperience':
        if (target.checked) {
          value = [...profileForm.populationExperience, target.value as string];
        } else {
          value = profileForm.populationExperience.filter(item => item !== value);
        } 
        break;
      case 'employmentStatus':
        if(value !== 'Working Full-Time' && value !== 'Working Part-Time') {
          profileForm.employerName = '';
          profileForm.jobName = '';
        }
        break;
    }

    let updatedForm = {
      ...profileForm,
      [name || ""]: value
    }
    
    setProfileForm(updatedForm);

  }

  let onLicenseFormChange = (event: React.ChangeEvent<HTMLInputElement | {name?: string, value:unknown, checked?: boolean}>) => {
    let { target } = event;
    
    let {value} = target;
    let name: string = target.name || '';
    let nameParts = ('' + name).split('.')
    if(nameParts.length > 1) {
      nameParts.shift()
      name = nameParts.join();
    }
    let updatedForm = {
      ...licenseForm,
      [name || ""]: value
    }
    setLicenseForm(updatedForm);
  }
  
  let afterValidate = (event: ValidationEvent<HTMLInputElement>) => {
    setValidations({
      ...validations,
      [event.target.name]: event.isValid
    });
  }

  const handleTabChange = (event: React.ChangeEvent<{}>, tab: number) => {
    setCurrentTab(tab);
  };

  const handleArray = (val: any) => {
    const clean = (val || []).reduce((a: string[], v: any) => {
      let _v: string;
      console.log(v);
      if (typeof v === 'object') {
        _v = JSON.stringify(v).trim();
      } else {
        _v = v.trim();
      }
      if (_v !== '' && _v !== '{}') {
        a.push(_v);
      }
      return a;
    }, []);
    return clean.join(';')
    // return JSON.stringify(val)
  }

  const getAvailability = (day: any) => {
    const val = profileForm.daysOfTheWeekAvailability.find(f => f.indexOf(day) === 0) || ''
    if(val === '') return val
    return val.replace(`${day} `, '')
  }

  let onSave = async (event: React.MouseEvent<HTMLButtonElement>) => {
    let values = Object.values(validations);
    if(values.every(x => x)) {
      setIsLoading(true)
      let user:any = {};//new UserImpl();
      let address:any = {};// = new AddressImpl();
      user.address = address;
      user.id = cognitoUserInfo.sub
      user.email = cognitoUserInfo.email
      user.phoneNumber = profileForm.phoneNumber
      user.firstName = profileForm.firstName
      user.lastName = profileForm.lastName
      user.address.line1 = profileForm.addressLine1;
      user.address.line2 = profileForm.addressLine2;
      user.address.city = profileForm.addressCity;
      user.address.state = profileForm.addressState;
      user.address.zipCode = profileForm.addressZipCode;
      user.address.country = profileForm.addressCountry;
      user.agreesToTerms = agreesToTerms;

      // these arent working
      // Employment status
      // Certifications
      // Parttime/full time
      // How far willing to travel
      // Willing to relocate
      // Available to start
      // Availability
      // telehealth visits
      //  treat critical care patients

      user.employmentStatus = profileForm.employmentStatus;
      user.employerName = profileForm.employerName;
      user.jobName = profileForm.jobName;
      user.certifications = profileForm.certifications;
      user.maxTravelMiles = profileForm.maxTravelMiles;
      user.willRelocate = profileForm.relocatable === '1';
      user.relocationZipCode1 = profileForm.relocationZipCode1;
      user.relocationZipCode2 = profileForm.relocationZipCode2;
      user.relocationZipCode3 = profileForm.relocationZipCode3;
      user.relocationReqHousing1 = profileForm.relocationReqHousing1 === '1';
      user.relocationReqHousing2 = profileForm.relocationReqHousing2 === '1';
      user.relocationReqHousing3 = profileForm.relocationReqHousing3 === '1';
      user.availableToStart = profileForm.availableToStart;
      user.retirementStatus = profileForm.retirementStatus;
      user.languageSpoken = profileForm.languageSpoken;

      user.employmentSought = '0'
      user.telehealthAvailability = profileForm.telehealthAvailability;
      user.inPersonCare = profileForm.treatCriticalCarePatients;

      // 0 = none
      // 1 = part-time
      // 2 = full time
      // 3 = both
      if(profileForm.partTimeInterest) {
        if(profileForm.fullTimeInterest) user.employmentSought = '3';
        else user.employmentSought = '1';
      } else {
        if(profileForm.fullTimeInterest) user.employmentSought = '2';
      }

      user.maxTravelMiles = profileForm.maxTravelMiles;
      user.treatCovidPatients = profileForm.treatCovidPatients;
      user.salaryType = profileForm.salaryType;
      user.lowerSalary = profileForm.lowerSalary;
      user.upperSalary = profileForm.upperSalary;
      user.availableToStart = profileForm.availableToStart;
      user.languageSpoken = profileForm.languageSpoken;
      user.retirementStatus = profileForm.retirementStatus;

      user.sundayAvailability = getAvailability('Sunday');
      user.mondayAvailability = getAvailability('Monday');
      user.tuesdayAvailability = getAvailability('Tuesday');
      user.wednesdayAvailability = getAvailability('Wednesday');
      user.thursdayAvailability = getAvailability('Thursday');
      user.fridayAvailability = getAvailability('Friday');
      user.saturdayAvailability = getAvailability('Saturday');
      user.specialities = handleArray(profileForm.specialities);
      user.populationExperience = handleArray(profileForm.populationExperience);
      user.recentExperience = profileForm.recentExperience;
      user.licenses = handleArray(profileForm.licenses);

      // console.log(JSON.stringify(user))

      try {
        const opts = {
          url: `${apiEndpoint}/users`,
          data: user,
          // data: profileForm,
          method: 'PUT',
          responseType: "application/json",
          headers: {
            'Authorization': getAuthHeader(),
            'x-api-key': apiKey
          }
        }
        // console.log(api.users)
        // console.log(id)
        // console.log(opts)
        let response = await axios(opts);
        setIsLoading(false)
        bus.emit(Events.onAlert, {
          message: 'Saved',
          duration: 5000
        });
        let tab = currentTab + 1
        if(tab > 4 && alreadyAgreedToTerms) {
          props.history.push({
            pathname: '/home',
          });
        } else {
          setCurrentTab(tab)
        }        
        getUser()

      } catch (err) {
        setIsLoading(false)
        console.log(err);
        const message = get(err, 'message');
        bus.emit(Events.onAlert, {
          message,
          severity: 'error',
          duration: 5000
        });
      }
    }

  }

  const theme = useTheme()
  // let isBig = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <Page className={classes.root}>
      <Loading isLoading={isLoading} />
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h6" align="center" className={classes.pageTitle}>Build Your Profile</Typography>
        </Grid>
        <Grid item xs={12}>
          {/* <Container className={classes.tabsContainer}> */}
            <AppBar position="static" color="default" >
            <Tabs
              variant = { "fullWidth" }
              orientation={ "horizontal"}
              value={currentTab}
              onChange={handleTabChange}
              
            >
              <Tab label={contactInfoLabel} {...a11yProps(0)} />
              {/* <Tab label="Employer Info" {...a11yProps(1)} /> */}
              <Tab label={workStatusLabel} {...a11yProps(1)} />
              <Tab label={availabilityLabel} {...a11yProps(2)} />
              <Tab label={preferencesLabel} {...a11yProps(3)} />
              <Tab label={resumeLabel} {...a11yProps(4)} />
            </Tabs>
            </AppBar>
            <TabPanel value={currentTab} index={0}>
              {/* CONTACT INFO */}
              <Grid container>
                {/* <Grid item xs={5}>
                  <div style={{width:'100%'}}>
                    <ImageDropZone dropzoneText="Profile Picture" className='dropzone'/>
                  </div>
                </Grid>          
                <Grid item xs={1}></Grid> */}
                <Grid item xs={11} sm={9} md={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <ValidatedTextField
                        fullWidth
                        required
                        name = "firstName"
                        label = "First Name"
                        value = { profileForm.firstName } 
                        onChange = { onProfileFormChange }
                        afterValidate = { afterValidate }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <ValidatedTextField
                        fullWidth
                        required
                        name = "lastName"
                        label = "Last Name"
                        value = { profileForm.lastName } 
                        onChange = { onProfileFormChange }
                        afterValidate = { afterValidate }
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <ValidatedTextField
                      email
                      disabled
                      fullWidth
                      name = "email"
                      label = "Email"
                      value = { cognitoUserInfo.email } 
                    />
                    <ValidatedTextField
                      fullWidth
                      required
                      name = "phoneNumber"
                      label = "Phone"
                      value = { profileForm.phoneNumber } 
                      onChange = { onProfileFormChange }
                      afterValidate = { afterValidate }
                    />     
                  </Grid>
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={6}>
                  <br/>
                  <Typography>Primary Address:</Typography>
                  <CountrySelect
                    name = "addressCountry"
                    label = "Country"
                    group = "contactInfo"
                    value = { profileForm.addressCountry } 
                    onChange = { onProfileFormChange }
                  />
                  <ValidatedTextField
                    fullWidth
                    name = "addressLine1"
                    label = "Address"
                    group = "contactInfo"
                    value = { profileForm.addressLine1 } 
                    onChange = { onProfileFormChange }
                  /> 
                  <ValidatedTextField
                    fullWidth
                    name = "addressLine2"
                    label = ""
                    value = { profileForm.addressLine2 } 
                    onChange = { onProfileFormChange }
                  /> 
                  <ValidatedTextField
                    fullWidth
                    name = "addressCity"
                    label = "City"
                    value = { profileForm.addressCity } 
                    onChange = { onProfileFormChange }
                  /> 
                  
                  <USStateSelect
                    fullWidth
                    name = "addressState"
                    label = "State"
                    value = { profileForm.addressState } 
                    onChange = { onProfileFormChange }
                  />
                  
                  <ValidatedTextField
                    fullWidth
                    required
                    name = "addressZipCode"
                    label = "Zip Code"
                    value = { profileForm.addressZipCode } 
                    onChange = { onProfileFormChange }
                  />
                </Grid>
              </Grid>
            </TabPanel>

            {/* <TabPanel value={currentTab} index={1}>
              
              <Grid container>  
                <Grid item xs={6}>
                  <ValidatedTextField
                    fullWidth
                    name = "orgName"
                    label = "Name of your Organization"
                    value = { form.orgName } 
                    onChange = { onChange }
                  />
                  
                  <ValidatedTextField
                    fullWidth
                    name = "orgWebsite"
                    label = "Company Website"
                    value = { form.orgWebsite } 
                    onChange = { onChange }
                  />

                  <ValidatedTextField
                    fullWidth            
                    name = "orgPhone"
                    label = "General Information Phone"
                    value = { form.orgPhone } 
                    onChange = { onChange }
                  />

                  <ValidatedTextField
                    email
                    fullWidth
                    name = "orgEmail"
                    label = "General Information Email"
                    value = { form.orgEmail } 
                    onChange = { onChange }
                    afterValidate = { afterValidate }
                  />
                  <br/><br/>
                  <Typography>Where is your organization located?</Typography>

                  <ValidatedTextField
                    fullWidth
                    name = "orgAddressLine1"
                    label = "Address:"
                    value = { form.orgAddressLine1 } 
                    onChange = { onChange }
                  />   

                  <ValidatedTextField
                    fullWidth
                    name = "orgAddressLine2"
                    label = ""
                    value = { form.orgAddressLine2 } 
                    onChange = { onChange }
                  />               

                  <ValidatedTextField
                    fullWidth
                    name = "orgCity"
                    label = "City:"
                    value = { form.orgCity } 
                    onChange = { onChange }
                  />   

                  <USStateSelect
                    name = "orgState"
                    label = "State"
                    value = { form.orgState } 
                    onChange = { onChange }
                  />     
                  
                  <ValidatedTextField
                    fullWidth
                    name = "orgZipCode"
                    label = "ZipCode:"
                    value = { form.orgZipCode } 
                    onChange = { onChange }
                  />   

                  <CountrySelect
                    name = "orgCountry"
                    label = "Country"
                    value = { form.orgCountry } 
                    onChange = { onChange }
                  /> 
                              
                </Grid>
              </Grid>
            </TabPanel> */}
            <TabPanel value={currentTab} index={1}>
              {/* Work Status */}
              <Grid container>
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    
                    <Button 
                      variant="contained"
                      color="primary"
                      aria-label = "Add" 
                      className = { clsx(classes.button) }
                      onClick = {() => {setIsAddLicenseModalVisible(true);}}
                    >
                      <AddBox className={ classes.buttonIcon } /> Add Medical Licenses
                    </Button>
                  </Grid>

                  {isAddLicenseModalVisible && 
                    <Dialog
                      // disableBackdropClick 
                      fullWidth={true}
                      maxWidth = {'sm'}
                      open={isAddLicenseModalVisible}
                      onClose={() => {setIsAddLicenseModalVisible(false)}}>

                        <FormGroup className={classes.dialogPaper}>
                          <Typography variant="h5" align="center">Add a License</Typography>  
                          <ValidatedSelect
                            id="licenseForm.name" 
                            labelId="licenseName-label"
                            name="licenseForm.name" 
                            value={ licenseForm.name }                 
                            onChange={ onLicenseFormChange }
                            label="License"
                            >
                            {availableLicenses.map((name) => (
                              <MenuItem key={name} value={name}>
                                <ListItemText primary={name} />
                              </MenuItem>
                            ))}
                          </ValidatedSelect>                          
                          <USStateSelect
                            name = "licenseForm.state"
                            label = "State"
                            value = { licenseForm.state } 
                            onChange = { onLicenseFormChange }
                          />  

                          <ValidatedTextField
                            required 
                            name = "licenseForm.number"
                            label = "License Number"
                            aria-label = "License Number" 
                            value = { licenseForm.number } 
                            onChange = { onLicenseFormChange }
                            afterValidate = { afterValidate }
                          />
                          <ValidatedTextField
                            date
                            name = "licenseForm.activationDate"
                            label = "Activation Date"
                            placeholder = "mm/dd/yyyy"
                            value = { licenseForm.activationDate } 
                            onChange = { onLicenseFormChange }
                            afterValidate = { afterValidate }
                          />
                          <ValidatedTextField
                            date
                            name = "licenseForm.expirationDate"
                            label = "Expiration Date"
                            placeholder = "mm/dd/yyyy"
                            value = { licenseForm.expirationDate } 
                            onChange = { onLicenseFormChange }
                            afterValidate = { afterValidate }
                          />
                        </FormGroup>
                        <Button 
                          variant="contained"
                          color="primary"
                          aria-label = "Add" 
                          className = { clsx(classes.button, classes.squareTop) }
                          onClick = { async () => {await addLicense();}}
                        >
                          <NoteAdd className={ classes.buttonIcon } />
                          Add
                        </Button>
                    </Dialog>
                  }
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    {profileForm.licenses.map((license) => (
                      <FormControlLabel
                      key={`licenseLabel-${license.name}`}
                      control={
                        <Checkbox
                          key={`license-${license.name}`}
                          className={classes.indent}
                          checked={profileForm.licenses.includes(license)}
                          onChange={onProfileFormChange}
                          name="licenses"
                          value={JSON.stringify(license)}
                        />
                      }
                      label={ `${license.name} [${license.number}]` }
                      />                
                    ))}
                    <br/>
                    <br/>  
                    <ValidatedSelect
                      multiple 
                      id="specialities" 
                      labelId="specialities-label"
                      name="specialities" 
                      value={profileForm.specialities}                 
                      onChange={onProfileFormChange}
                      label="Specialities"
                      renderValue={(selected: string[]) => {
                        if (selected.length === 0) {
                          return "";
                        }
                        return selected.join(', ');
                      }}>
                      {availableSpecialities.map((name) => (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={profileForm.specialities.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </ValidatedSelect>    
                  </Grid>   
                  <br/>
                  <br/>
                  <Grid item xs={12}>
                    <Typography>Population Experience</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    {availablePopulationExperiences.map((name) => (
                      <FormControlLabel
                      key={`populationExperienceLabel-${name}`}
                      control={
                        <Checkbox
                          key={`populationExperience-${name}`}
                          className={classes.indent}
                          checked={profileForm.populationExperience.indexOf(name) > -1}
                          onChange={onProfileFormChange}
                          name="populationExperience"
                          value={name}
                        />
                      }
                      label={name}
                      />                
                    ))}
                  </Grid>
                  <br/>
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    <ValidatedSelect
                        id="employmentStatus" 
                        labelId="employmentStatus-label"
                        name="employmentStatus" 
                        value={profileForm.employmentStatus}                 
                        onChange={onProfileFormChange}
                        label="Employment Status"
                      >
                      {availableEmploymentStatuses.map((name) => (
                        <MenuItem key={name} value={name}>
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                      </ValidatedSelect>                   
                    {/* <Collapse in={profileForm.employmentStatus === 'Employed Part-Time' || profileForm.employmentStatus === 'Employed Full-Time'}>
                      <ValidatedTextField
                        fullWidth
                        name = "employerName"
                        label = "Employer Name"
                        value = { profileForm.employerName } 
                        onChange = { onProfileFormChange }
                      />

                      <ValidatedTextField
                        fullWidth
                        name = "jobName"
                        label = "Your role"
                        value = { profileForm.jobName } 
                        onChange = { onProfileFormChange }
                      />
                    </Collapse> */}
                    <Collapse in={profileForm.employmentStatus === 'Student'}>
                      <br/>
                      <Typography>What are you majoring in?</Typography>
                      <ValidatedTextField
                        fullWidth
                        name = "studentMajor"
                        label = "Major"
                        value = { profileForm.studentMajor } 
                        onChange = { onProfileFormChange }
                      />
                    </Collapse> 
                    <br/>    
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>When did you most recently practice?</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    <ValidatedSelect
                        id="recentExperience" 
                        labelId="recentExperience-label"
                        name="recentExperience" 
                        value={profileForm.recentExperience}                 
                        onChange={onProfileFormChange}
                        label="Most Recent Experience"
                      >
                      {availableRecentExperienceOptions.map((name) => (
                        <MenuItem key={name} value={name}>
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </ValidatedSelect>  
                    <br/><br/>
                  </Grid>
                  {/* <Grid item xs={12}>
                    <Typography>Do you have any certifications?</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    <ValidatedSelect
                      multiple 
                      id="certifications" 
                      labelId="certifications-label"
                      name="certifications" 
                      value={profileForm.certifications}                 
                      onChange={onProfileFormChange}
                      label="Certifications"
                      renderValue={(selected: string[]) => {
                        if (selected.length === 0) {
                          return "";
                        }
                        return selected.join(', ');
                      }}>
                      {availableCertifications.map((name) => (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={profileForm.certifications.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </ValidatedSelect>                          
                  </Grid> */}
                </Grid>
              </Grid>      
            </TabPanel>
            <TabPanel value={currentTab} index={2}>
              {/* Availability */}
              <Grid container>
                <Grid item xs={12}> 
                  <Typography display="inline">What is your expected </Typography>
                  <Select
                    id="salaryType" 
                    variant = "filled"
                    margin = "dense"
                    name="salaryType" 
                    value={profileForm.salaryType}                 
                    onChange={onProfileFormChange}
                  >
                    <MenuItem key="hourly" value="hourly">
                      <ListItemText primary="hourly" />
                    </MenuItem>
                    <MenuItem key="annual" value="annual">
                      <ListItemText primary="annual" />
                    </MenuItem>
                  </Select> 
                  <Typography display="inline"> salary range?</Typography>
                  <br/>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedTextField
                    name = "lowerSalary"
                    style = {{width: '9em'}}
                    label = "From"
                    value = { profileForm.lowerSalary } 
                    onChange = { onProfileFormChange }
                    afterValidate = { afterValidate }
                  />
                  <ValidatedTextField
                    name = "upperSalary"
                    style = {{width: '9em'}}
                    label = "To"
                    value = { profileForm.upperSalary } 
                    onChange = { onProfileFormChange }
                    afterValidate = { afterValidate }
                  />  
                  <br/><br/>
                </Grid>
                <Grid item xs={12}>
                  <Typography>Are you looking for part-time or full-time work?</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.indent}
                        checked={profileForm.partTimeInterest}
                        onChange={onProfileFormChange}
                        name="partTimeInterest"
                      />
                    }
                    label="Part-Time"
                  /> 
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.indent}
                        checked={profileForm.fullTimeInterest}
                        onChange={onProfileFormChange}
                        name="fullTimeInterest"
                      />
                    }
                    label="Full-Time"
                  /> 
                  <br/><br/>
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography>How far are you willing to travel?</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedSelect
                    id="maxTravelMiles" 
                    labelId="maxTravelMiles-label"
                    name="maxTravelMiles" 
                    value={profileForm.maxTravelMiles}                 
                    onChange={onProfileFormChange}
                    label="Travel"
                    >
                    {availableTravelDistances.map((el: any) => (
                      <MenuItem key={el.value} value={el.value}>
                        <ListItemText primary={el.label} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect>
                    <br/><br/>
                </Grid> */}
                <Grid item xs={12}>
                  <Typography>Are you willing to travel or relocate?</Typography>
                  <RadioGroup row aria-label="relocatable" name="relocatable" value={profileForm.relocatable} className={classes.indent} onChange={onProfileFormChange}>
                    <FormControlLabel value = "1" control={<Radio />} label="Yes" />
                    <FormControlLabel value = "0" control={<Radio />} label="No" />
                  </RadioGroup>
                </Grid>              
                <Collapse in={profileForm.relocatable === "1"}>
                  <div style={{position: 'relative', 'left': '5em'}}>
                    <Typography>Please provide a few locations you are willing to relocate to</Typography>
                    <br/>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <ValidatedTextField
                        fullWidth
                        name = "relocationZipCode1"
                        label = "Zip Code of Interest"
                        value = { profileForm.relocationZipCode1 } 
                        onChange = { onProfileFormChange }
                      />
                      <Typography>Do you need accommodations at this location?</Typography>
                      <RadioGroup row aria-label="relocationReqHousing1" name="relocationReqHousing1" value={profileForm.relocationReqHousing1} className={classes.indent} onChange={onProfileFormChange}>
                        <FormControlLabel value = "1" control={<Radio />} label="Yes" />
                        <FormControlLabel value = "0" control={<Radio />} label="No" />
                      </RadioGroup>
                    </Grid>
                    <br/>
                    <hr/>
                    <br/>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <ValidatedTextField
                        fullWidth
                        name = "relocationZipCode2"
                        label = "Zip Code of Interest"
                        value = { profileForm.relocationZipCode2 } 
                        onChange = { onProfileFormChange }
                      />
                      <Typography>Do you need accommodations at this location?</Typography>
                      <RadioGroup row aria-label="relocationReqHousing2" name="relocationReqHousing2" value={profileForm.relocationReqHousing2} className={classes.indent} onChange={onProfileFormChange}>
                        <FormControlLabel value = "1" control={<Radio />} label="Yes" />
                        <FormControlLabel value = "0" control={<Radio />} label="No" />
                      </RadioGroup>
                    </Grid>
                    <br/>
                    <hr/>
                    <br/>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <ValidatedTextField
                        fullWidth
                        name = "relocationZipCode3"
                        label = "Zip Code of Interest"
                        value = { profileForm.relocationZipCode3 } 
                        onChange = { onProfileFormChange }
                      />
                      <Typography>Do you need accommodations at this location?</Typography>
                      <RadioGroup row aria-label="relocationReqHousing3" name="relocationReqHousing3" value={profileForm.relocationReqHousing3} className={classes.indent} onChange={onProfileFormChange}>
                        <FormControlLabel value = "1" control={<Radio />} label="Yes" />
                        <FormControlLabel value = "0" control={<Radio />} label="No" />
                      </RadioGroup>                    
                    </Grid>   
                  </div>                                 
                </Collapse>  
                <Grid item xs={12}>
                  <br/>
                  <Typography>When are you available to start?</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedSelect
                    id="availableToStart" 
                    labelId="availableToStart-label"
                    name="availableToStart" 
                    value={profileForm.availableToStart}                 
                    onChange={onProfileFormChange}
                    label="Available"
                    >
                    {availableToStartOptions.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        <ListItemText primary={el.label} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect>
                  <br/><br/>
                </Grid>
                <Grid item xs={12}>
                  <Typography>What days/times are you available to work?</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedSelect
                    multiple 
                    id="daysOfTheWeekAvailability" 
                    labelId="daysOfTheWeekAvailability-label"
                    name="daysOfTheWeekAvailability" 
                    value={profileForm.daysOfTheWeekAvailability}                 
                    onChange={onProfileFormChange}
                    label="Days"
                    renderValue={(selected: string[]) => {
                      if (selected.length === 0) {
                        return "";
                      }
                      return selected.join(', ');
                    }}>
                    {daysOfTheWeek.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={profileForm.daysOfTheWeekAvailability.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect>
                  {/* <ValidatedSelect
                    multiple 
                    id="shiftAvailability" 
                    labelId="shiftAvailability-label"
                    name="shiftAvailability" 
                    value={form.shiftAvailability}                 
                    onChange={onChange}
                    label="Shift Availability"
                    renderValue={(selected: string[]) => {
                      if (selected.length === 0) {
                        return "";
                      }
                      return selected.join(', ');
                    }}>
                    {shiftAvailabilityOptions.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={form.shiftAvailability.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect> */}
                </Grid>
                <Grid item xs={12}>
                  <br/>
                  <Typography>Languages Spoken?</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedSelect
                    id="languageSpoken" 
                    labelId="languageSpoken-label"
                    name="languageSpoken" 
                    value={profileForm.languageSpoken}                 
                    onChange={onProfileFormChange}
                    label="Languages"
                    >
                    {languagesSpokenOptions.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        <ListItemText primary={el.label} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect>
                  <br/><br/>
                </Grid>
                <Grid item xs={12}>
                  <br/>
                  <Typography>Retirement Status</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={6}>
                  <ValidatedSelect
                    id="retirementStatus" 
                    labelId="retirementStatus-label"
                    name="retirementStatus" 
                    value={profileForm.retirementStatus}                 
                    onChange={onProfileFormChange}
                    label="Retirement Status"
                    >
                    {retirementStatusOptions.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        <ListItemText primary={el.label} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect>
                  <br/><br/>
                </Grid>
              </Grid>                
            </TabPanel> 
            <TabPanel value={currentTab} index={3}>
              <Grid container>
                <Grid item xs={12}> 
                  <Typography>Are you willing to conduct telehealth visits?</Typography>
                  <RadioGroup row aria-label="telehealthAvailability" name="telehealthAvailability" value={profileForm.telehealthAvailability} className={classes.indent} onChange={onProfileFormChange}>
                    <FormControlLabel value = "1" control={<Radio />} label="Yes" />
                    <FormControlLabel value = "0" control={<Radio />} label="No" />
                  </RadioGroup>   
                  <br/>
                  <Typography>Are you able and willing to treat COVID-19 positive patients in person?</Typography>
                  <RadioGroup row aria-label="treatCovidPatients" name="treatCovidPatients" value={profileForm.treatCovidPatients} className={classes.indent} onChange={onProfileFormChange}>
                    <FormControlLabel value = "Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value = "No" control={<Radio />} label="No" />
                  </RadioGroup>   
                  <br/>
                  <Typography>Are you able and willing to treat critical care patients in person?</Typography>
                  <RadioGroup row aria-label="treatCriticalCarePatients" name="treatCriticalCarePatients" value={profileForm.treatCriticalCarePatients} className={classes.indent} onChange={onProfileFormChange}>
                    <FormControlLabel value = "Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value = "No" control={<Radio />} label="No" />
                  </RadioGroup>                           
                  {/* <br/>
                  <Typography>What is your personal COVID-19 status?</Typography>
                  <ValidatedSelect
                    id="covidStatus" 
                    labelId="covidStatus-label"
                    name="covidStatus" 
                    value={form.covidStatus}                 
                    onChange={onChange}
                    label="COVID-19 Status"
                    >
                    {availableCovidStatuses.map((name) => (
                      <MenuItem key={name} value={name}>
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </ValidatedSelect> */}
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={currentTab} index={4}>
            <Grid container>
                <Grid item xs={12}> 
                  { alreadyAgreedToTerms &&
                  <div>
                    <Typography>Upload your Resume (or another to replace it)</Typography>
                    <div style={{width:'80%', margin: '0 auto'}}>
                      
                      <ResumeDropZone dropzoneText="Drag here" className='dropzone' onChange ={(files: File[]) => { 
                        console.log('files: ', files); 
                        let resumeFile = files && files.length > 0 ? files[0] : undefined
                        if(resumeFile) {
                          uploadResume(resumeFile)
                        }
                      }}/>
                      <br/>
                      {resumeFilename &&  <div>Previously saved: <Link to='#' target='_self' onClick={downloadResume} >{decodeURIComponent(resumeFilename)}</Link></div>}

                      {/* <br/>
                      <Button 
                        variant="contained"
                        color="primary"
                        aria-label = "Upload" 
                        className = { clsx(classes.button) }
                        onClick = {uploadResume}>
                          Upload
                      </Button> */}
                    </div>
                  </div>
                  }
                  { !alreadyAgreedToTerms &&
                    <div>You have not accepted the Terms of Use and Privacy Policy yet.<br/><br/>Please accept the terms and click Next to continue.</div>
                   }
                </Grid>
              </Grid>
            </TabPanel>
          {/* </Container> */}
          <div>
            <br/><br/>
            <Grid item xs={4} className={`${classes.left}`}>
              <Button 
                disabled={!agreesToTerms}
                variant="contained"
                color="primary"
                aria-label = "Save and Continue"
                className = { `${classes.button} ${classes.right}` }
                onClick = { onSave }
              >
                Next
              </Button>
            </Grid>
            {!alreadyAgreedToTerms && <div>
              <Grid item xs={2} className={`${classes.left}`}>
                <Checkbox
                  name="agreesToTerms"
                  color="primary"
                  checked={agreesToTerms}
                  value={agreesToTerms}
                  onChange={(e) =>{
                    setAlreadyAgreedToTerms(e.target.checked)
                    setAgreesToTerms(e.target.checked)}}
                />
              </Grid>
              <Grid item xs={4} className={`${classes.left}`}>
                <p className={`${classes.left} ${classes.legalText}`}>By checking this box I agree to the <Link to='/legal' target='_blank' onClick={_ => window.localStorage.setItem('usccLegalPageTab', '0') } >Terms of Use</Link> and <Link to='/legal' target='_blank' onClick={_ => window.localStorage.setItem('usccLegalPageTab', '1') }>Privacy Policy</Link></p>
              </Grid></div>}
          </div>
        </Grid>
        
      </Grid>
      {/* <Grid item xs={12} className = { classes.bottom }>
        <Button 
          variant="contained"
          color="primary"
          aria-label = "Register" 
          className = { clsx(classes.button, classes.right) }
          endIcon = {
            <Icon className = { clsx(classes.buttonIcon,  'fa fa-angle-right') } />
          }
          onClick = { (event) => {

            // let pathname = (form.registerBusiness === 'yes') ? 'business-profile' : 'member-home';
            let pathname = 'business-profile';
            user.firstName = form.firstName;
            user.lastName = form.lastName;
            user.email = form.email;
            
            let address = new AddressImpl();
            address.city = form.city || '';
            address.state = form.state || '';
            address.country = form.country || '';
            
            user.address = address;
            user.phoneNumber = form.phoneNumber;
            user.maxTravelMiles = form.maxTravelMiles;

            bus.emit(Events.onLogin, { user: user});

            props.history.push({
              pathname: pathname,
              state: {
                user: user
              }
            });
          }}
        >
          Continue
        </Button>          
        </Grid>*/}       
    </Page>
  );
}